export const USERS_TABLE = {
    'USERS.COLUMN.NAME': 'Nume',
    'USERS.COLUMN.EMAIL': 'E-mail',
    'USERS.COLUMN.NO_OF_CLIENTS': 'Asociat nr. clienți',
    'USERS.COLUMN.NO_OF_COMPANIES': 'Asociat nr. companii',
    'USERS.COLUMN.STATUS': 'Status',
    'USERS.COLUMN.DATE': 'Dată actualizare',
    'USERS.COLUMN.UPDATED_BY': 'Actualizat de',
    'USERS.COLUMN.ACTIONS': 'Acțiuni',
    'USERS.SEARCH_PLACEHOLDER': 'Caută Nume/E-mail',
    'USERS.ACTION.ADD': 'Utilizator nou',
    'USERS.ACTION.EDIT': 'Editează',
    'USERS.ACTION.VIEW': 'Vizualizează',
    'USERS.FILTER.STATUS': 'Status'
};
